"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var rule_constants_1 = require("./rule-constants");
exports.defaultValues = {
    type: rule_constants_1.conditionTypes.programContains,
    value: undefined,
};
/** Factory that generates Immutable [[IProgramValueCondition]] */
exports.ProgramValueConditionRecord = immutable_1.Record(exports.defaultValues);
/** class that represents an immutable version of the [[IProgramValueCondition]] */
var ImmutableProgramValueCondition = /** @class */ (function (_super) {
    __extends(ImmutableProgramValueCondition, _super);
    function ImmutableProgramValueCondition(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableProgramValueCondition;
}(exports.ProgramValueConditionRecord));
exports.ImmutableProgramValueCondition = ImmutableProgramValueCondition;
//# sourceMappingURL=program-value-condition.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-rules/program-value-condition.js
// module id = 1118
// module chunks = 0